import {FormItemModel, FormOptionsModel} from '../../../services/models/form.model';
import {RequesterResponseModel} from '../../../services/models/requester.model';

export class SkillsCheckerFormResponseModel {
    status: RequesterResponseModel;
    form: SkillsCheckerFormModel;
}

export class SkillsCheckerFormRequestModel {
    type: string;
    form: SkillsCheckerFormModel;
}

export class SkillsCheckerFormModel {
    grp_id: number; // tslint:disable-line:variable-name
    del_id: number; // tslint:disable-line:variable-name
    comments: FormItemModel;
    comments_manager: FormItemModel; // tslint:disable-line:variable-name
    questions: {
        value: SkillsCheckerFormQuestionModel[];
        options: FormOptionsModel;
        error: any;
    };
    completed_agreed: boolean; // tslint:disable-line:variable-name
    locked: FormItemModel;
    archived: FormItemModel;
    delegate: {
        fullname: string;
    };
    options: FormOptionsModel;
    error: any;
}

export class SkillsCheckerFormQuestionModel {
    id: number;
    question: string;
    competency: string;
    q_value_self: FormItemModel; // tslint:disable-line:variable-name
    q_value_manager: FormItemModel; // tslint:disable-line:variable-name
    q_value_agreed: FormItemModel; // tslint:disable-line:variable-name
    ordering: number;
}
